import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Typography,
  Paper,
  Alert,
  CircularProgress,
} from '@mui/material';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import { oauthService } from '../services/oauthService';

const Login: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleMicrosoftLogin = async () => {
    setError(null);
    setLoading(true);

    try {
      await oauthService.initiateLogin();
    } catch (err: any) {
      setError(err.message || 'Error al iniciar sesión con Microsoft');
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Panel de Administración CDP
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 3 }}>
            Inicia sesión con tu cuenta de Microsoft
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Button
            type="button"
            fullWidth
            variant="outlined"
            startIcon={loading ? <CircularProgress size={20} /> : <MicrosoftIcon />}
            onClick={handleMicrosoftLogin}
            disabled={loading}
            sx={{
              borderColor: '#0078d4',
              color: '#0078d4',
              py: 1.5,
              '&:hover': {
                borderColor: '#106ebe',
                backgroundColor: 'rgba(0, 120, 212, 0.04)',
              },
            }}
          >
            Iniciar sesión con Microsoft
          </Button>

          <Typography variant="caption" color="text.secondary" align="center" display="block" sx={{ mt: 2 }}>
            Usuarios internos: Usa tu cuenta @cdpdigital.com.pa
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
